export default __webpack_public_path__ + "static/media/raised-hand-new.c7d0cf51.svg";